/**
 * @desc sku销售预测-提交审批流
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: defs.basics.PlmSkuForecastApprovalRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/forecast/saveAndCommit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
